"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountLimitServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/layouts/default-layout/component");
const backendImport_1 = require("@front/backendImport");
const events_1 = require("@front/event/events");
const SignalService_1 = __importStar(require("@front/services/SignalService"));
let AccountLimitService = class AccountLimitService extends client_1.RWSService {
    constructor(apiService, signalService) {
        super();
        this.apiService = apiService;
        this.signalService = signalService;
        this.resourceLimits = {
            'avatar': {
                limitProperty: 'maxAvatars',
                messageKey: 'limits.avatar.exceeded'
            },
            'user': {
                limitProperty: 'maxUsers',
                messageKey: 'limits.user.exceeded'
            },
            'project': {
                limitProperty: 'maxProjectsCount',
                messageKey: 'limits.project.exceeded'
            },
            'knowledge': {
                limitProperty: 'maxKnowledgeEntries',
                messageKey: 'limits.knowledge.exceeded'
            },
            'trainer': {
                limitProperty: 'customAiModels',
                messageKey: 'limits.customModel.exceeded'
            },
            'style': {
                limitProperty: null, // No count limit, only feature flag
                featureProperty: 'writingStyles',
                messageKey: 'limits.writingStyles.disabled'
            }
        };
        this.featureChecks = {
            'advanced-prompts': 'advancedPrompts',
            'prompt-assist': 'promptAssist',
            'anti-hallucination': 'antiHallucination',
            'advanced-reports': 'advancedReports',
            'chat-thread-sharing': 'chatThreadSharing',
            'custom-branding': 'customBranding',
            'widgets': 'widgets',
            'voice-agent': 'voiceAgent',
            'writing-styles': 'writingStyles'
        };
    }
    shouldSkipLimits(user) {
        if (!user)
            return false;
        return user.role === backendImport_1.UserRoles.SUPER_ADMIN || user.role === backendImport_1.UserRoles.ENTERPRISE || user.role === backendImport_1.UserRoles.PARENT_USER;
    }
    async checkResourceLimit(resource, currentCount) {
        const user = component_1.DefaultLayout.USER;
        if (!user || !user.accountGrade) {
            return {
                canCreate: false,
                message: 'limits.noAccountGrade'.t()
            };
        }
        // Skip limits for SUPER_ADMIN and ENTERPRISE users
        if (this.shouldSkipLimits(user)) {
            return { canCreate: true };
        }
        const resourceConfig = this.resourceLimits[resource];
        if (!resourceConfig) {
            // If no configuration found, assume unlimited
            return { canCreate: true };
        }
        const accountGrade = user.accountGrade;
        // Check feature access first if defined
        if (resourceConfig.featureProperty) {
            const featureEnabled = accountGrade[resourceConfig.featureProperty];
            if (!featureEnabled) {
                const message = resourceConfig.messageKey.t();
                this.sendLimitSignal(resource, message, 'feature');
                return {
                    canCreate: false,
                    message,
                    feature: resourceConfig.featureProperty.toString()
                };
            }
        }
        // Check limits if defined
        if (resourceConfig.limitProperty) {
            const limit = accountGrade[resourceConfig.limitProperty];
            // null means unlimited
            if (limit === null) {
                return { canCreate: true };
            }
            // 0 means disabled
            if (limit === 0) {
                const message = resourceConfig.messageKey.t();
                this.sendLimitSignal(resource, message, 'count');
                return {
                    canCreate: false,
                    message
                };
            }
            // If we have a current count, check against limit
            if (currentCount !== undefined) {
                if (currentCount >= limit) {
                    const message = resourceConfig.messageKey.t().replace('{limit}', limit.toString());
                    this.sendLimitSignal(resource, message, 'count');
                    return {
                        canCreate: false,
                        message
                    };
                }
            }
        }
        return { canCreate: true };
    }
    sendLimitSignal(resource, message, limitType = 'count') {
        try {
            const limitSignal = this.signalService.getSignal('account-limit-reached');
            limitSignal.setValue({
                resource,
                message,
                limitType,
                timestamp: Date.now(),
                upgradeLink: 'limits.upgrade.link'.t()
            });
        }
        catch (error) {
            console.error('Error sending limit signal:', error);
        }
    }
    async checkFeatureAccess(feature) {
        const user = component_1.DefaultLayout.USER;
        if (!user || !user.accountGrade) {
            return {
                canCreate: false,
                message: 'limits.noAccountGrade'.t()
            };
        }
        // Skip feature checks for SUPER_ADMIN and ENTERPRISE users
        if (this.shouldSkipLimits(user)) {
            return { canCreate: true };
        }
        const featureProperty = this.featureChecks[feature];
        if (!featureProperty) {
            // If no configuration found, assume enabled
            return { canCreate: true };
        }
        const featureEnabled = user.accountGrade[featureProperty];
        if (!featureEnabled) {
            const message = `limits.${feature}.disabled`.t();
            this.sendLimitSignal(feature, message, 'feature');
            return {
                canCreate: false,
                message,
                feature: featureProperty.toString()
            };
        }
        return { canCreate: true };
    }
    async getCurrentResourceCount(resource) {
        try {
            let endpoint;
            let countProperty = 'count';
            switch (resource) {
                case 'avatar':
                    endpoint = 'avatar.list';
                    break;
                case 'user':
                    endpoint = 'user.list';
                    break;
                case 'project':
                    endpoint = 'project.list';
                    break;
                case 'knowledge':
                    endpoint = 'knowledge.list';
                    break;
                case 'trainer':
                    endpoint = 'trainer.custom-models';
                    break;
                case 'style':
                    endpoint = 'style.list';
                    break;
                default:
                    return 0;
            }
            const response = await this.apiService.back.get(endpoint, {
                queryParams: { per_page: '1' } // We only need the count
            });
            return (response === null || response === void 0 ? void 0 : response.count) || 0;
        }
        catch (error) {
            console.error(`Error fetching ${resource} count:`, error);
            return 0;
        }
    }
    async checkResourceLimitWithCount(resource) {
        const currentCount = await this.getCurrentResourceCount(resource);
        return this.checkResourceLimit(resource, currentCount);
    }
    async checkBulkResourceLimit(resource, itemsToAddCount) {
        const user = component_1.DefaultLayout.USER;
        if (!user || !user.accountGrade) {
            return {
                canCreate: false,
                message: 'limits.noAccountGrade'.t()
            };
        }
        // Skip limits for SUPER_ADMIN and ENTERPRISE users
        if (this.shouldSkipLimits(user)) {
            return { canCreate: true };
        }
        const resourceConfig = this.resourceLimits[resource];
        if (!resourceConfig) {
            // If no configuration found, assume unlimited
            return { canCreate: true };
        }
        const accountGrade = user.accountGrade;
        // Check feature access first
        if (resourceConfig.featureProperty) {
            const featureEnabled = accountGrade[resourceConfig.featureProperty];
            if (!featureEnabled) {
                return {
                    canCreate: false,
                    message: 'limits.featureDisabled'.t()
                };
            }
        }
        // Check limits
        if (resourceConfig.limitProperty) {
            const limit = accountGrade[resourceConfig.limitProperty];
            if (limit === 0) {
                return {
                    canCreate: false,
                    message: 'limits.featureDisabled'.t()
                };
            }
            if (limit !== null) {
                const currentCount = await this.getCurrentResourceCount(resource);
                const totalAfterUpload = currentCount + itemsToAddCount;
                if (totalAfterUpload > limit) {
                    const remainingSlots = limit - currentCount;
                    return {
                        canCreate: false,
                        message: 'limits.bulk.exceeded'.t()
                            .replace('{itemsToAdd}', itemsToAddCount.toString())
                            .replace('{remainingSlots}', remainingSlots.toString())
                            .replace('{limit}', limit.toString())
                    };
                }
            }
        }
        return { canCreate: true };
    }
    showLimitExceededPopup(message) {
        // Use existing popup system to show limit exceeded message
        component_1.DefaultLayout.$instance.$emit(events_1.appEvents.popupShow, {
            message: message,
            type: 'warning'
        });
    }
    getLimitTooltip(resource) {
        const user = component_1.DefaultLayout.USER;
        if (!user || !user.accountGrade) {
            return 'limits.noAccountGrade'.t();
        }
        // No tooltip needed for privileged users
        if (this.shouldSkipLimits(user)) {
            return '';
        }
        const resourceConfig = this.resourceLimits[resource];
        if (!resourceConfig) {
            return '';
        }
        const accountGrade = user.accountGrade;
        // Check feature access first
        if (resourceConfig.featureProperty) {
            const featureEnabled = accountGrade[resourceConfig.featureProperty];
            if (!featureEnabled) {
                return resourceConfig.messageKey.t();
            }
        }
        // Check limits
        if (resourceConfig.limitProperty) {
            const limit = accountGrade[resourceConfig.limitProperty];
            if (limit === 0) {
                return resourceConfig.messageKey.t();
            }
            if (limit !== null) {
                return `limits.${resource}.limitReached`.t().replace('{limit}', limit.toString());
            }
        }
        return '';
    }
    isResourceDisabled(resource) {
        const user = component_1.DefaultLayout.USER;
        if (!user || !user.accountGrade) {
            return true;
        }
        // Never disabled for privileged users
        if (this.shouldSkipLimits(user)) {
            return false;
        }
        const resourceConfig = this.resourceLimits[resource];
        if (!resourceConfig) {
            return false;
        }
        const accountGrade = user.accountGrade;
        // Check feature access
        if (resourceConfig.featureProperty) {
            const featureEnabled = accountGrade[resourceConfig.featureProperty];
            if (!featureEnabled) {
                return true;
            }
        }
        // Check if limit is 0 (disabled)
        if (resourceConfig.limitProperty) {
            const limit = accountGrade[resourceConfig.limitProperty];
            if (limit === 0) {
                return true;
            }
        }
        return false;
    }
};
exports.AccountLimitServiceInstance = AccountLimitService;
exports.AccountLimitServiceInstance = AccountLimitService = __decorate([
    __param(0, client_1.ApiService),
    __param(1, SignalService_1.default),
    __metadata("design:paramtypes", [typeof (_a = typeof client_1.ApiServiceInstance !== "undefined" && client_1.ApiServiceInstance) === "function" ? _a : Object, typeof (_b = typeof SignalService_1.SignalServiceInstance !== "undefined" && SignalService_1.SignalServiceInstance) === "function" ? _b : Object])
], AccountLimitService);
exports.default = AccountLimitService.getSingleton();
